import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Operadora } from '@gestor-web/@core/api/ords/model';

@Component({
    selector: 'bl-links-externos',
    templateUrl: './links-externos.component.html',
    styleUrls: ['./links-externos.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinksExternosComponent {
  @Input() operadora: Operadora;
}
